// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_apexcharts_dist_apexcharts_esm_js":"a1f6bcc3e8851b11","node_modules_apexcharts_dist_core_esm_js":"d546f0d1b87f6416","node_modules_apexcharts_dist_apexcharts_ssr_esm_js":"003af49c04cd4ef4"}[chunkId] + ".js";
};